import $ from "jquery";
import "slick-carousel/slick/slick";

const initBenefitFromCarousel = () => {
  const benefitFromCarousel = $(".js-benefit-from-carousel");
  const windowWidth = $(window).width();
  const destroyBreakpoint = 830;

  if (windowWidth > destroyBreakpoint) {
    if (benefitFromCarousel.hasClass("slick-initialized")) {
      benefitFromCarousel.slick("unslick");
    }
  } else if (benefitFromCarousel.length) {
    benefitFromCarousel.not(".slick-initialized")
      .slick({
        dots: true,
        arrows: false,
        cssEase: "linear",
        speed: 150,
        autoplaySpeed: 4000,
        autoplay: false,
        infinite: true,
        centerMode: true,
        variableWidth: true,
        pauseOnHover: true,
        pauseOnFocus: false,
        pauseOnDotsHover: !(
          !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)
        )
      });
  }
};
$(window).on("load resize", initBenefitFromCarousel);
